import { Stack, SxProps, Typography } from '@mui/material';

import { BaseReference } from '~interfaces';
import i18n from '~lib/i18n';
import { Dimens } from '~themes';

import Dropdown from './dropdown';

interface LanguageDropdownProps {
	selectedValue?: BaseReference;
	onValueChanged: (newValue?: BaseReference) => void;
	label?: string;
	sx?: SxProps;
}

const LanguageDropdown = ({
	label = i18n.t('user.fields.language', { ns: 'entities' }),
	...props
}: LanguageDropdownProps) => {
	// Data
	// Transform to full locale code (e.g. en -> en-EN)
	// This works for now as we only have languages with same language and country code
	// in the format xx-XX. If we add more languages in the future, we need to adjust this.
	// But i18n is now set up with only en, de, nl and not with en-EN, de-DE, nl-NL
	const allLanguages =
		(i18n.options.supportedLngs as string[] | undefined)
			?.filter((lng) => lng !== 'cimode' && lng !== 'dev')
			.map((language) => ({
				id: `${language}-${language.toUpperCase()}`,
				name: new Intl.DisplayNames(i18n.language, { type: 'language' }).of(language) || language,
			})) || [];

	const handleOptionSelected = (value: BaseReference | null) => {
		props.onValueChanged({
			id: value?.id ?? '',
			name: value?.name ?? '',
		});
	};

	// Component
	return (
		<Stack sx={{ gap: Dimens.spacingXs }}>
			{label && <Typography variant='labelSm'>{label}</Typography>}
			<Dropdown
				values={allLanguages}
				value={props.selectedValue ?? allLanguages[0]}
				onValueChanged={handleOptionSelected}
				canClear={false}
				sx={{
					width: 300,
					...props.sx,
				}}
			/>
		</Stack>
	);
};

export default LanguageDropdown;
